export default __webpack_public_path__ + "static/media/Path3417.96a37923.svg";